import React from "react";

const EmptyData = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 80 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.6273 0H0V58.8971H42.6273V0Z"
      transform="rotate(-12.11 65.666 -25.172)"
      fill="#E0E0E0"
    />
    <path
      opacity="0.5"
      d="M41.1866 0H0V56.9062H41.1866V0Z"
      transform="rotate(-12.11 70 -29.067)"
      fill="url(#paint0_linear)"
    />
    <path
      d="M40.138 0H0V55.649H40.138V0Z"
      transform="rotate(-12.11 71.712 -31.745)"
      fill="#FAFAFA"
    />
    <path
      d="M19.912 0H0V4.82339H19.912V0Z"
      transform="rotate(-12.11 55.257 -78.457)"
      fill="url(#paint1_linear)"
    />
    <path
      d="M2.1891 0.061182C0.685999 0.384042 -0.265023 1.893 0.0656407 3.43121C0.396304 4.96943 1.88185 5.95654 3.38203 5.63369C4.8822 5.31082 5.83615 3.80187 5.50549 2.26365C5.17482 0.725435 3.6922 -0.261678 2.1891 0.061182ZM3.13232 4.46027C2.81465 4.53603 2.48161 4.51549 2.17565 4.40127C1.86969 4.28705 1.60467 4.08431 1.41436 3.81891C1.22405 3.5535 1.11707 3.23744 1.10706 2.91101C1.09704 2.58458 1.18445 2.26256 1.35814 1.98599C1.53182 1.70942 1.78392 1.49083 2.08231 1.35807C2.38069 1.22531 2.71185 1.1844 3.03357 1.24055C3.35529 1.2967 3.65301 1.44737 3.88878 1.67335C4.12455 1.89933 4.2877 2.1904 4.35743 2.50945C4.40561 2.71801 4.41211 2.93404 4.37656 3.14512C4.34101 3.3562 4.2641 3.55817 4.15026 3.73945C4.03643 3.92072 3.8879 4.07771 3.71321 4.20141C3.53852 4.32511 3.34111 4.41308 3.13232 4.46027Z"
      transform="translate(24.245 3.09)"
      fill="url(#paint2_linear)"
    />
    <path
      d="M19.4925 0H0V4.61075H19.4925V0Z"
      transform="rotate(-12.11 54.177 -79.341)"
      fill="#EF5753"
    />
    <path
      d="M2.1526 0.0606637C1.6258 0.173735 1.14435 0.440479 0.769137 0.827167C0.393926 1.21385 0.141806 1.70312 0.0446539 2.23309C-0.0524979 2.76307 0.00968223 3.30995 0.223334 3.80458C0.436985 4.29922 0.792513 4.71939 1.24496 5.01197C1.6974 5.30455 2.22644 5.4564 2.76519 5.44832C3.30393 5.44024 3.82818 5.27258 4.27164 4.96656C4.71511 4.66053 5.05787 4.22988 5.25658 3.72906C5.45529 3.22823 5.50104 2.67973 5.38803 2.15291C5.31299 1.80308 5.16977 1.47146 4.96656 1.17698C4.76334 0.882505 4.50411 0.63094 4.20367 0.436654C3.90323 0.242367 3.56746 0.109165 3.21554 0.044652C2.86361 -0.0198609 2.50243 -0.01442 2.1526 0.0606637ZM3.05388 4.26467C2.74981 4.32992 2.43321 4.30352 2.14413 4.18883C1.85506 4.07414 1.60649 3.8763 1.42986 3.62033C1.25323 3.36436 1.15647 3.06176 1.15182 2.7508C1.14718 2.43984 1.23485 2.13448 1.40375 1.87335C1.57266 1.61222 1.81521 1.40704 2.10073 1.28376C2.38624 1.16048 2.70191 1.12464 3.0078 1.18077C3.31369 1.2369 3.59606 1.38248 3.81921 1.5991C4.04235 1.81572 4.19625 2.09365 4.26143 2.39774C4.34883 2.80544 4.27071 3.23116 4.04426 3.58126C3.8178 3.93137 3.46156 4.17719 3.05388 4.26467Z"
      transform="translate(24.282 3.09)"
      fill="#EF5753"
    />
    <path
      d="M42.6273 0H0V58.8971H42.6273V0Z"
      transform="translate(25.155 11.403)"
      fill="#E0E0E0"
    />
    <path
      opacity="0.5"
      d="M41.1866 0H0V56.9063H41.1866V0Z"
      transform="translate(25.876 12.4)"
      fill="url(#paint3_linear)"
    />
    <path
      d="M40.138 0H0V55.649H40.138V0Z"
      transform="translate(26.4 12.819)"
      fill="#fff"
    />
    <path
      d="M19.912 0H0V4.82339H19.912V0Z"
      transform="translate(36.565 10.406)"
      fill="url(#paint4_linear)"
    />
    <path
      d="M2.78381 0C1.24657 0 7.1441e-07 1.27583 7.1441e-07 2.85014C7.1441e-07 4.42445 1.24657 5.70028 2.78381 5.70028C4.32105 5.70028 5.56763 4.42445 5.56763 2.85014C5.56763 1.27583 4.32105 0 2.78381 0ZM2.78381 4.49468C2.457 4.50243 2.1353 4.41261 1.85977 4.23669C1.58424 4.06077 1.3674 3.80672 1.23693 3.50698C1.10645 3.20725 1.06827 2.87543 1.12725 2.55389C1.18623 2.23236 1.3397 1.9357 1.56806 1.70178C1.79642 1.46787 2.08931 1.30733 2.40934 1.24064C2.72937 1.17396 3.06201 1.20417 3.36479 1.32741C3.66757 1.45065 3.92675 1.66134 4.10924 1.93256C4.29173 2.20378 4.38924 2.52324 4.38933 2.85014C4.39246 3.27979 4.2253 3.69319 3.92443 3.99992C3.62355 4.30664 3.21344 4.48173 2.78381 4.48687V4.49468Z"
      transform="translate(43.737 5.697)"
      fill="url(#paint5_linear)"
    />
    <path
      d="M19.4925 0H0V4.61075H19.4925V0Z"
      transform="translate(36.775 10.199)"
      fill="#EF5753"
    />
    <path
      d="M2.72431 0C2.18549 0 1.65878 0.159778 1.21076 0.45913C0.762753 0.758481 0.413573 1.18396 0.207376 1.68176C0.00117901 2.17957 -0.0527693 2.72734 0.0523489 3.2558C0.157467 3.78427 0.416935 4.26969 0.797937 4.65069C1.17894 5.0317 1.66436 5.29116 2.19283 5.39628C2.72129 5.5014 3.26906 5.44745 3.76686 5.24125C4.26467 5.03505 4.69015 4.68587 4.9895 4.23786C5.28885 3.78985 5.44863 3.26313 5.44863 2.72431C5.44863 2.00178 5.1616 1.30884 4.6507 0.797933C4.13979 0.287025 3.44685 0 2.72431 0ZM2.72431 4.29667C2.41358 4.29628 2.10993 4.20384 1.8517 4.031C1.59347 3.85817 1.39224 3.61269 1.27341 3.32558C1.15459 3.03846 1.12351 2.72257 1.18408 2.4178C1.24466 2.11303 1.39417 1.83304 1.61376 1.61318C1.83334 1.39332 2.11315 1.24345 2.41784 1.1825C2.72254 1.12155 3.03847 1.15225 3.32573 1.27071C3.613 1.38918 3.85872 1.59011 4.03187 1.84812C4.20503 2.10614 4.29785 2.40968 4.29862 2.72041C4.29849 2.92698 4.25766 3.1315 4.17846 3.32228C4.09927 3.51306 3.98325 3.68637 3.83705 3.8323C3.69085 3.97822 3.51733 4.09392 3.32641 4.17276C3.13548 4.2516 2.93088 4.29205 2.72431 4.29179V4.29667Z"
      transform="translate(43.797 5.697)"
      fill="#EF5753"
    />
    <g opacity="0.5" fill="#47E6B1">
      <path
        opacity="0.5"
        d="M0.366753 0H0V2.08054H0.366753V0Z"
        transform="translate(1.49 71.892)"
      />
      <path
        opacity="0.5"
        d="M0.366753 2.38137e-06H0V2.08054H0.366753V2.38137e-06Z"
        transform="rotate(90 -35.018 37.732)"
      />
    </g>
    <g opacity="0.5" fill="#47E6B1">
      <path
        opacity="0.5"
        d="M0.366753 0H0V2.08054H0.366753V0Z"
        transform="translate(44.039)"
      />
      <path
        opacity="0.5"
        d="M0.366751 0H2.38137e-06V2.08054H0.366751V0Z"
        transform="rotate(90 22.203 23.06)"
      />
    </g>
    <path
      opacity="0.5"
      d="M1.503 0.83192C1.40184 0.787884 1.3204 0.708191 1.27418 0.608012C1.22796 0.507833 1.22017 0.394159 1.25232 0.288617C1.25751 0.272474 1.26078 0.255777 1.26208 0.23887C1.26499 0.190562 1.25226 0.142601 1.22579 0.102085C1.19932 0.0615689 1.16051 0.0306498 1.1151 0.0139088C1.06969 -0.00283214 1.0201 -0.00450368 0.973668 0.00913417C0.927233 0.022772 0.886423 0.0509934 0.857279 0.0896303C0.847136 0.103218 0.838623 0.117951 0.831917 0.133525C0.787881 0.234684 0.708194 0.316128 0.608015 0.36235C0.507836 0.408573 0.394156 0.416349 0.288614 0.384205C0.272472 0.379017 0.255774 0.375746 0.238868 0.374454C0.190559 0.371543 0.142598 0.384264 0.102082 0.410734C0.0615661 0.437203 0.0306529 0.476011 0.0139119 0.52142C-0.00282904 0.566828 -0.00450653 0.61642 0.00913132 0.662855C0.0227692 0.70929 0.0509965 0.7501 0.0896334 0.779244C0.103221 0.789387 0.117954 0.7979 0.133528 0.804606C0.234687 0.848641 0.316125 0.928329 0.362347 1.02851C0.40857 1.12869 0.416353 1.24237 0.384208 1.34791C0.379021 1.36405 0.375743 1.38075 0.374451 1.39766C0.37154 1.44596 0.384261 1.49392 0.410731 1.53444C0.437201 1.57496 0.476014 1.60587 0.521423 1.62261C0.566831 1.63935 0.616423 1.64103 0.662858 1.62739C0.709293 1.61375 0.750103 1.58553 0.779247 1.54689C0.78939 1.5333 0.797903 1.51857 0.804609 1.503C0.848644 1.40184 0.928332 1.3204 1.02851 1.27418C1.12869 1.22795 1.24236 1.22018 1.34791 1.25232C1.36405 1.25751 1.38075 1.26078 1.39765 1.26207C1.44596 1.26498 1.49392 1.25226 1.53444 1.22579C1.57495 1.19932 1.60587 1.16051 1.62261 1.1151C1.63935 1.06969 1.64103 1.0201 1.62739 0.973665C1.61376 0.92723 1.58553 0.88642 1.54689 0.857276C1.5333 0.847133 1.51857 0.838626 1.503 0.83192Z"
      transform="translate(73.709 74.524)"
      fill="#4D8AF0"
    />
    <path
      opacity="0.5"
      d="M1.503 0.83192C1.40184 0.787884 1.3204 0.708191 1.27418 0.608012C1.22795 0.507833 1.22017 0.39416 1.25232 0.288617C1.2575 0.272475 1.26078 0.255777 1.26207 0.238871C1.26498 0.190562 1.25226 0.142601 1.22579 0.102085C1.19932 0.0615691 1.16051 0.03065 1.1151 0.013909C1.06969 -0.0028319 1.0201 -0.00450939 0.973668 0.00912846C0.927233 0.0227663 0.886422 0.0509936 0.857278 0.0896305C0.847135 0.103218 0.838623 0.117951 0.831917 0.133525C0.787881 0.234685 0.708191 0.316128 0.608012 0.362351C0.507833 0.408573 0.394159 0.41635 0.288617 0.384206C0.272474 0.379018 0.255777 0.375746 0.23887 0.374454C0.190562 0.371543 0.142601 0.384264 0.102085 0.410734C0.0615687 0.437204 0.0306495 0.476011 0.0139086 0.52142C-0.00283238 0.566828 -0.00450689 0.61642 0.00913096 0.662855C0.0227688 0.70929 0.0509961 0.7501 0.089633 0.779244C0.103221 0.789387 0.117951 0.7979 0.133525 0.804606C0.234684 0.848642 0.316124 0.928329 0.362347 1.02851C0.40857 1.12869 0.416349 1.24237 0.384205 1.34791C0.379017 1.36405 0.375743 1.38075 0.37445 1.39766C0.37154 1.44596 0.384261 1.49392 0.41073 1.53444C0.4372 1.57496 0.476014 1.60587 0.521422 1.62261C0.566831 1.63935 0.616423 1.64103 0.662858 1.62739C0.709292 1.61375 0.750103 1.58553 0.779247 1.54689C0.78939 1.5333 0.7979 1.51857 0.804605 1.503C0.848641 1.40184 0.928331 1.3204 1.02851 1.27418C1.12869 1.22795 1.24237 1.22018 1.34791 1.25232C1.36405 1.25751 1.38075 1.26078 1.39765 1.26207C1.44596 1.26498 1.49392 1.25226 1.53444 1.22579C1.57496 1.19932 1.60587 1.16051 1.62261 1.1151C1.63935 1.06969 1.64103 1.0201 1.62739 0.973665C1.61375 0.92723 1.58553 0.88642 1.54689 0.857276C1.5333 0.847133 1.51857 0.838626 1.503 0.83192Z"
      transform="translate(11.828 54.523)"
      fill="#FDD835"
    />
    <path
      opacity="0.5"
      d="M1.503 0.831917C1.40184 0.787881 1.3204 0.708192 1.27418 0.608013C1.22796 0.507834 1.22017 0.394157 1.25232 0.288615C1.25751 0.272472 1.26078 0.255777 1.26208 0.23887C1.26499 0.190561 1.25226 0.1426 1.22579 0.102084C1.19932 0.0615677 1.16051 0.0306508 1.1151 0.0139098C1.06969 -0.00283112 1.0201 -0.00450639 0.973668 0.00913146C0.927233 0.0227693 0.886423 0.0509959 0.857279 0.0896328C0.847136 0.103221 0.838623 0.117952 0.831917 0.133526C0.787881 0.234685 0.708194 0.316125 0.608015 0.362348C0.507836 0.40857 0.394156 0.41635 0.288614 0.384206C0.272472 0.379018 0.255774 0.375744 0.238868 0.374452C0.190559 0.371541 0.142598 0.384262 0.102082 0.410732C0.0615661 0.437201 0.0306529 0.476013 0.0139119 0.521421C-0.00282904 0.56683 -0.00450653 0.616422 0.00913132 0.662857C0.0227692 0.709291 0.0509965 0.750102 0.0896334 0.779246C0.103221 0.789389 0.117954 0.7979 0.133528 0.804606C0.234687 0.848642 0.316125 0.928331 0.362347 1.02851C0.40857 1.12869 0.416353 1.24237 0.384208 1.34791C0.379021 1.36405 0.375743 1.38075 0.374451 1.39765C0.37154 1.44596 0.384261 1.49392 0.410731 1.53444C0.437201 1.57496 0.476014 1.60587 0.521423 1.62261C0.566831 1.63935 0.616423 1.64103 0.662858 1.62739C0.709293 1.61375 0.750103 1.58553 0.779247 1.54689C0.78939 1.5333 0.797903 1.51857 0.804609 1.503C0.848644 1.40184 0.928332 1.3204 1.02851 1.27418C1.12869 1.22795 1.24236 1.22017 1.34791 1.25232C1.36405 1.25751 1.38075 1.26078 1.39765 1.26207C1.44596 1.26498 1.49392 1.25226 1.53444 1.22579C1.57495 1.19932 1.60587 1.16051 1.62261 1.1151C1.63935 1.06969 1.64103 1.0201 1.62739 0.973667C1.61376 0.927232 1.58553 0.886422 1.54689 0.857278C1.5333 0.847135 1.51857 0.838623 1.503 0.831917Z"
      transform="translate(63.37 5.818)"
      fill="#FDD835"
    />
    <path
      opacity="0.5"
      d="M0.734483 1.46896C1.14013 1.46896 1.46896 1.14013 1.46896 0.734482C1.46896 0.328839 1.14013 0 0.734483 0C0.32884 0 0 0.328839 0 0.734482C0 1.14013 0.32884 1.46896 0.734483 1.46896Z"
      transform="translate(78.531 29.94)"
      fill="#F55F44"
    />
    <path
      opacity="0.5"
      d="M0.734481 1.46896C1.14012 1.46896 1.46896 1.14013 1.46896 0.734484C1.46896 0.328841 1.14012 0 0.734481 0C0.328838 0 0 0.328841 0 0.734484C0 1.14013 0.328838 1.46896 0.734481 1.46896Z"
      transform="translate(21.771 72.094)"
      fill="#F55F44"
    />
    <path
      opacity="0.5"
      d="M0.734482 1.46896C1.14012 1.46896 1.46897 1.14013 1.46897 0.734483C1.46897 0.32884 1.14012 0 0.734482 0C0.328838 0 2.85764e-06 0.32884 2.85764e-06 0.734483C2.85764e-06 1.14013 0.328838 1.46896 0.734482 1.46896Z"
      transform="translate(70.988 45.815)"
      fill="#F55F44"
    />
    <path
      opacity="0.5"
      d="M0.734482 1.46896C1.14012 1.46896 1.46896 1.14012 1.46896 0.734482C1.46896 0.328839 1.14012 0 0.734482 0C0.328839 0 0 0.328839 0 0.734482C0 1.14012 0.328839 1.46896 0.734482 1.46896Z"
      transform="translate(7.765 8.664)"
      fill="#4D8AF0"
    />
    <path
      opacity="0.5"
      d="M0.734482 1.46896C1.14013 1.46896 1.46896 1.14013 1.46896 0.734483C1.46896 0.32884 1.14013 0 0.734482 0C0.328839 0 0 0.32884 0 0.734483C0 1.14013 0.328839 1.46896 0.734482 1.46896Z"
      transform="translate(0 28.7)"
      fill="#47E6B1"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-90 24.523 32.383) scale(56.9063)"
      >
        <stop stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 -238.517 984.647 0 10257.3 869.941)"
      >
        <stop stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-69.8076 -325.346 318.269 -68.2891 2944.14 190.14)"
      >
        <stop stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="scale(24028.7 33199.7) rotate(-90 .767 .45)"
      >
        <stop stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 -238.517 984.647 0 9004.49 753.076)"
      >
        <stop stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 -333.124 325.372 0 3550.14 1005.47)"
      >
        <stop stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
    </defs>
  </svg>
);

export default EmptyData;



// WEBPACK FOOTER //
// ../shop_main/images/emptyData.js